var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"search-box",class:{ 'leads-search': _vm.leadSearch },attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }